import { useEffect, useState } from "react";
import { navLinks } from "@/mocks/home";

export default function Navbar() {
  const [open, setOpen] = useState(false);
  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 12);
    onScroll();
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <header
      className={`fixed top-0 left-0 right-0 z-50 transition-colors duration-300 ${
        scrolled
          ? "bg-background-50/95 border-b border-background-200/70 backdrop-blur"
          : "bg-background-50/70 border-b border-transparent backdrop-blur-sm"
      }`}
    >
      <div className="w-full px-4 md:px-8 h-16 flex items-center justify-between">
        <a href="#top" className="flex items-center gap-2.5 cursor-pointer">
          <span className="w-9 h-9 rounded-md bg-primary-500 text-background-50 flex items-center justify-center">
            <i className="ri-focus-3-line text-lg" aria-hidden="true"></i>
          </span>
          <span className="font-heading font-bold text-lg tracking-wide text-foreground-950">
            黑料照片
          </span>
          <span className="hidden sm:inline-block ml-1 text-[11px] px-2 py-0.5 rounded-full bg-secondary-100 text-secondary-900 font-label">
            鉴定室
          </span>
        </a>

        <nav className="hidden lg:flex items-center gap-7">
          {navLinks.map((link) => (
            <a
              key={link.href}
              href={link.href}
              className="text-sm text-foreground-700 hover:text-primary-600 transition-colors cursor-pointer whitespace-nowrap"
            >
              {link.label}
            </a>
          ))}
        </nav>

        <div className="hidden md:flex items-center gap-3">
          <button
            type="button"
            className="w-9 h-9 rounded-md border border-background-300 flex items-center justify-center text-foreground-700 hover:border-primary-300 hover:text-primary-600 transition-colors cursor-pointer"
            aria-label="搜索案例"
          >
            <i className="ri-search-line"></i>
          </button>
          <a
            href="#submit"
            className="text-sm px-4 py-2 rounded-md border border-primary-300 text-primary-700 hover:bg-primary-50 transition-colors cursor-pointer whitespace-nowrap"
          >
            提交照片
          </a>
          <button
            type="button"
            className="text-sm px-4 py-2 rounded-md bg-primary-500 text-background-50 hover:bg-primary-600 transition-colors cursor-pointer whitespace-nowrap"
          >
            加入鉴定团
          </button>
        </div>

        <button
          type="button"
          onClick={() => setOpen((v) => !v)}
          className="lg:hidden w-10 h-10 rounded-md border border-background-300 flex items-center justify-center text-foreground-800 cursor-pointer"
          aria-label="打开菜单"
        >
          <i className={open ? "ri-close-line text-xl" : "ri-menu-line text-xl"}></i>
        </button>
      </div>

      {open && (
        <div className="lg:hidden border-t border-background-200 bg-background-50 px-4 py-3">
          <nav className="flex flex-col">
            {navLinks.map((link) => (
              <a
                key={link.href}
                href={link.href}
                onClick={() => setOpen(false)}
                className="py-3 text-sm text-foreground-800 border-b border-background-100 last:border-0 cursor-pointer"
              >
                {link.label}
              </a>
            ))}
          </nav>
          <div className="flex gap-3 pt-3">
            <a
              href="#submit"
              onClick={() => setOpen(false)}
              className="flex-1 text-center text-sm px-4 py-2.5 rounded-md border border-primary-300 text-primary-700 cursor-pointer whitespace-nowrap"
            >
              提交照片
            </a>
            <button
              type="button"
              className="flex-1 text-sm px-4 py-2.5 rounded-md bg-primary-500 text-background-50 cursor-pointer whitespace-nowrap"
            >
              加入鉴定团
            </button>
          </div>
        </div>
      )}
    </header>
  );
}